import { useMemo } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (cfg) => {
      const token = await getToken();
      if (token) cfg.headers.Authorization = `Bearer ${token}`;
      return cfg;
    });
    return inst;
  }, [getToken]);
}

export const publicApi = axios.create({ baseURL: API });

export const photoUrl = (p) => (!p ? null : p.startsWith("/") || p.startsWith("http") ? p : `${API}/files/${p}`);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(" · ");
  return d || "Une erreur est survenue";
};

export const eur = (n) => `${Number(n || 0).toLocaleString("fr-FR", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 })} €`;

export const dateFr = (s) => (s ? new Date(s).toLocaleString("fr-FR", { dateStyle: "medium", timeStyle: "short" }) : "—");

export const STATUS_LABELS = {
  active: "Disponible", reserved: "Réservé", sold: "Vendu", given: "Donné", closed: "Clôturé", suspended: "Suspendu",
  pending: "En attente", accepted: "Acceptée", rejected: "Refusée", expired: "Expirée", cancelled: "Annulée",
  completed: "Terminée", paid: "Payée", pending_payment: "Paiement en attente", delivered: "Livrée", refunded: "Remboursée",
  approved: "Approuvée", appeal: "Recours", open: "Ouverte", quoted: "Devis reçus", booked: "Réservée",
  needs_review: "Vérification requise", scheduled: "Planifiée", requested: "Demandée", confirmed: "Confirmée",
  courier_assigned: "Coursier assigné", picked_up: "Collecté", in_transit: "En route", recipient_absent: "Destinataire absent",
  returned: "Retourné", refused: "Refusée", resolved: "Résolu", dismissed: "Classé",
};

export const ROLE_LABELS = { admin: "Administrateur", provider: "Prestataire", pro: "Professionnel", member: "Particulier" };
